<template>
  <section>
    <br>
    <p class="p-style">
      Step 4: Review Visit Details
    </p>
    <div class="steps-div">
      <p class="steps-name">
        Location Verification<v-icon
          right
          size="18"
          color="#2E7D32"
        >
          mdi-checkbox-marked-circle
        </v-icon>
      </p>
      <p class="steps-name">
        Purpose of Visit<v-icon
          right
          size="18"
          color="#2E7D32"
        >
          mdi-checkbox-marked-circle
        </v-icon>
      </p>
      <p class="steps-name">
        Questions & Answers<v-icon
          right
          size="18"
          color="#2E7D32"
        >
          mdi-checkbox-marked-circle
        </v-icon>
      </p>
    </div>
    <v-card
      class="card-style"
      color="#ECEFF1"
      :style="getBgStyle"
    >
      <v-card-text>
        <v-form>
          <div>
            <v-card
              class="user-card"
              light
            >
              <p class="user-content">
                Location:- <font class="font-my-style">
                  {{ locationName.site_name }}
                </font><br>Check-In Type
                :- <font class="font-my-style">
                  {{ checkInType }}
                </font>
              </p>
            </v-card>
            <p class="visit-content">
              Purpose of Visit:- <br><font
                v-if="visitPurpose.visit_purpose !== null"
                class="font-my-style"
              >
                {{ visitPurpose.visit_purpose }}
              </font>
              <font
                v-else
                class="font-my-style"
              >
                N/A
              </font>
            </p>
          </div>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#37474F"
            @click="cancel()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#FF3700"
            @click="checkIn()"
          >
            Check In
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card-text>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import moment from 'moment';

export default {
  name: 'ReviewVisitDetails',
  components: {
    'centre-spinner': spinner,
  },
  data: () => ({
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
    location: 'NSW Tafe',
    checkInType: 'Visitor',
  }),
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    visitPurpose () {
      return this.$store.getters['swiftuser/getVisitPurpose'];
    },
    selectedAnswers () {
      return this.$store.getters['questions/getUserSelectedAnswers'];
    },
    checkInId () {
      return this.$store.getters['swiftuser/getCheckInId'];
    },
    locationName () {
      return this.$store.getters['swiftuser/getLocationName'];
    },
  },
  methods: {
    checkIn () {
      this.loading = true;
      const siteId = this.$route.params.siteId;
      this.$store.dispatch('swiftuser/checkInUser', {
        checkin_time: moment.utc().format(),
        location_id: siteId,
        type: 'visitor',
      }).then(response => {
        this.completeCheckInProcess();
      }).catch(errors => {
        this.loading = false;
      });
    },
    async completeCheckInProcess () {
      const selectedAnswers = [];
      selectedAnswers.push({
        answers: this.selectedAnswers,
      });
      await this.$store.dispatch('questions/sendUserSelectedAnswers', {
        answers: selectedAnswers[0],
        checkInId: this.checkInId.id,
      }).then(response => {
        this.$store.dispatch('swiftuser/sendVisitDetails', {
        purpose: {
          purpose_of_visit: this.visitPurpose.visit_purpose,
        },
        checkInId: this.checkInId.id,
        }).then(response => {
          this.loading = false;
          this.$store.dispatch('alert/onAlert', {
            message: 'Check-In completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          const checkInId = this.checkInId.id;
          localStorage.setItem('checkIn', checkInId);
          this.$emit('checkin-completed');
        }).catch(() => {
          this.loading = false;
        });
      }).catch(() => {
        this.loading = false;
      });
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.steps-name {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  margin-left: 10px;
  font-family:'Times New Roman', Times, serif;
}
.steps-div {
  line-height:normal;
  margin-left: 10px;
  border-left: 3px solid #FF3700;
}
.user-content {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  margin-left: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-family:'Times New Roman', Times, serif;
}
.visit-content {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: #546E7A;
  font-family:'Times New Roman', Times, serif;
}
.font-my-style {
  font-weight: bold;
  font-size: 16px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
  text-transform: capitalize;
}
.user-card {
  border-left: 3px solid #546E7A !important;
  border-bottom: 3px solid #546E7A !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
